import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2bf36436"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "cs-container",
  style: {"width":"100vw","height":"100vh"}
}
const _hoisted_2 = { class: "relative w-full h-full" }
const _hoisted_3 = {
  class: "absolute",
  style: {"top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
}
const _hoisted_4 = { class: "overflow-hidden w-80 md:w-96 rounded-md shadow-xl" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center p-3 md:p-4",
  style: {"background-color":"#3a3a3a"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1))
const _hoisted_6 = { class: "p-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "font-extrabold text-5xl text-center" }, "로그인"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-2 text-desc text-md md:text-lg text-center" }, "안녕하세요, 관리자 페이지 입니다.")
], -1))
const _hoisted_8 = {
  class: "cs-form flex w-full bg-white",
  "data-height": "lg"
}
const _hoisted_9 = {
  class: "cs-form flex mt-2 w-full bg-white",
  "data-height": "lg"
}
const _hoisted_10 = {
  key: 0,
  class: "cs-feedback cs-feedback-error"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-comment-exclamation" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg md:text-xl font-bold" }, "로그인", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_button = _resolveComponent("loader-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.id) = $event)),
                type: "text",
                placeholder: "아이디 입력하세요."
              }, null, 512), [
                [_vModelText, _ctx.id]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                type: "password",
                placeholder: "비밀번호 입력하세요."
              }, null, 512), [
                [_vModelText, _ctx.password]
              ])
            ]),
            (_ctx.errMassage.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_ctx.errMassage), 1)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_loader_button, {
              ref: "submitLogin",
              class: "w-full cs-pd-btn-xl mt-8",
              cssButton: 'cs-btn-base',
              onLoaderClick: _ctx.onSubmit
            }, {
              title: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["onLoaderClick"])
          ])
        ])
      ])
    ])
  ]))
}